import { forwardRef } from "react"
import InputFactory from "./InputFactory"

const Field = forwardRef(function Field({label, type, error, ...props}, ref) {
  return (
    <div>
      <label htmlFor={props.id} className="block mb-2 text-sm font-medium text-gray-900">
        {label}
      </label>
      <InputFactory ref={ref} type={type} error={error} {...props}/>
    </div>
  )
})

export default Field
